import './normalize.css'
import './styles.css'
import NavBar from "./components/Navbar"
import Home from "./pages/Home"
import ChromeExtensions from "./pages/ChromeExtensions"
import Typed from 'react-typed'
import {Link, Routes, Route} from 'react-router-dom'
import React, {useRef, useState, useEffect } from 'react'
import Canvas from './components/Canvas'
import Footer from './components/Footer'
import AOS from "aos"
import "aos/dist/aos.css"
// import Floating from './components/Floating'


function App() {
  //Background animated gradient
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 })
  let gradientStyle = {
    background: `radial-gradient(at 100% 10%, #2E3D65, rgb(11, 17, 31)`,
  }

  if (window.innerWidth > 1280) {
    const gradientX = (cursorPosition.x / window.innerWidth) * 100
    const gradientY = (cursorPosition.y / window.innerHeight) * 100
      gradientStyle = {
      background: `radial-gradient(at ${gradientX}% ${gradientY}%, rgb(46, 61, 101), rgb(11, 17, 31)`,
    }
  }

  useEffect(() => { 
    AOS.init() // This initiates the animate on scroll library
    const handleMouseMove = (event) => {
      setCursorPosition({ x: event.clientX, y: event.clientY })
    }
    document.addEventListener('mousemove', handleMouseMove)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])


  return (
    <div className="App" style={gradientStyle}>
      <NavBar/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chrome-extensions" element={<ChromeExtensions />} />
      </Routes>
      <Footer/>
    </div>
  )
}

export default App
